module.exports = __webpack_public_path__ + "img/锂电池标签.d3e4cf95.jpg";